import { render } from "./private-agreement.vue?vue&type=template&id=78f72f2a&scoped=true"
const script = {}

import "./private-agreement.vue?vue&type=style&index=0&id=78f72f2a&scoped=true&lang=css"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f72f2a"]])

export default __exports__